import React, {useEffect,useState,useContext,useCallback} from 'react';
import { IMenuTree } from '../models/General';
import { useLocation, Link } from "react-router-dom";
import Family from './Family';

const Menu = (prop:any) => {

    const listMenu:IMenuTree[] = prop.data.dataMenu

    const [menuVal, setMenuVal] = useState<string>('');
    const name =  window.localStorage.getItem('name');
    const location = useLocation();
    const [padding, setPadding] = useState(0);


    useEffect(() => {

        const paths = location.pathname.split("/");
        setMenuVal(paths[1])
        
    },[])
    
    return (
        <React.Fragment>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <a href="/" className="brand-link">
                    <img src="/components/dist/img/AdminLTELogo.png" alt="Study Evaluation" className="brand-image img-circle elevation-3" style={{opacity: .8}}/>
                    <span className="brand-text font-weight-light">Academic</span>
                </a>
                <div className="sidebar" style={{padding: '0'}}>
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex" style={{paddingLeft: '0.5rem', paddingRight: '0.5rem', }} >
                        <div className="image">
                            
                        </div>
                        <div className="info nameuser">
                            <a href="#" className="d-block">{name}</a>
                        </div>
                    </div>
                   
                    <nav className="mt-2">
                        <div className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            {
                                Object.keys(listMenu).map((key:any) => listMenu[key]).map(((family) =>
                                    <Family key={family.MENU_ID} familyTree={family} padding={padding}/>
                                ))
                            }
                        </div>
                    </nav>
                </div>
            </aside>
        </React.Fragment>
   )
}

export default Menu;
